// @core/api/endpoints/authn/get_jwks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetJWKSResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get JSON Web Key Set
 * Returns the JSON Web Key Set containing public keys used to verify JWT signatures. Clients use these keys to validate ID tokens and access tokens.
 * @public This endpoint does not require authentication
 */
export async function GetJWKS(
  params?: {
  },
  options?: RequestOptions
): Promise<GetJWKSResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/.well-known/jwks.json`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetJWKSResponse>(requestPath, { ...requestOptions, params });
}
